import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiServices from "../../service";

const initialState: any = {
  listItems: [],

  activeItem: {},
  loading: false,
  activeItemloading: false,
};
export const getExpenseCategoryListItems = createAsyncThunk(
  "expenseCategories/getExpenseCategoryListItems",
  async (_, { rejectWithValue }) => {
    try {
      const response: any =
        await apiServices.systemManager.expenseCategory.getList();
      const { isError, data } = response.data;
      if (isError || !data) {
        return rejectWithValue("Failed to fetch  list");
      }

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

export const getExpenseCategoryDetailById = createAsyncThunk(
  "expenseCategories/getExpenseCategoryDetailById",
  async (Id: string, { getState, rejectWithValue }) => {
    if (!Id) return rejectWithValue("Invalid Id ID");

    // Access the current state
    const state: any = getState();

    const itemList = state.expenseCategories.listItems;

    // Find the valuation detail by ID in the listItems array
    const itemDetail = itemList.find((item: any) => item.id === Id);
    if (itemDetail) {
      return itemDetail; // Return the detail if found
    } else {
      return rejectWithValue("item detail not found in state");
    }
  }
);

export const expenseCategoriesSlice = createSlice({
  name: "expenseCategories",
  initialState,
  reducers: {
    setActiveExpenseCategory(state, action: any) {
      state.activeItem = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getExpenseCategoryListItems.pending, (state) => {
        state.loading = true;
        state.listItems = [];
      })
      .addCase(getExpenseCategoryListItems.fulfilled, (state, action) => {
        state.loading = false;
        state.listItems = action.payload;
      })
      .addCase(getExpenseCategoryListItems.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching  list:", action.payload);
      })
      .addCase(getExpenseCategoryDetailById.pending, (state) => {
        state.activeItemloading = true;
        state.activeItem = {};
      })
      .addCase(getExpenseCategoryDetailById.fulfilled, (state, action) => {
        state.activeItemloading = false;
        state.activeItem = action.payload;
      })
      .addCase(getExpenseCategoryDetailById.rejected, (state, action) => {
        state.activeItemloading = false;
        console.error("Error fetching asset details:", action.payload);
      });
  },
});
export const { setActiveExpenseCategory } = expenseCategoriesSlice.actions;
export default expenseCategoriesSlice.reducer;
